import React from 'react';

import { ColumnDividerBox } from '@eika-kortbetjening/column-divider-box';
import { Modal, ModalDialogProps } from '@eika/modal';

import { CreditCard, CreditCardAccount } from '@generated-types';
import useText from '@hooks/use-text';

import { CreditCardControlPanel } from '../../../CardControlPanel';
import { DesktopCardDetails } from '../../../DesktopCardDetails';

interface CardDetailsModalContentProps {
    card: CreditCard;
    account: CreditCardAccount;
}

const CardDetailsModalContent = ({ card, account }: CardDetailsModalContentProps) => {
    return (
        <ColumnDividerBox>
            <ColumnDividerBox.Item>
                <CreditCardControlPanel card={card} showButtons={false} />
            </ColumnDividerBox.Item>
            <DesktopCardDetails card={card} account={account} />
        </ColumnDividerBox>
    );
};

interface CardDetailsModalProps extends ModalDialogProps {
    card: CreditCard;
    account: CreditCardAccount;
}

const CardDetailsModal = (props: CardDetailsModalProps) => {
    const { cardLinkCardDetails } = useText();
    return (
        <Modal title={cardLinkCardDetails} {...props}>
            <CardDetailsModalContent card={props.card} account={props.account} />
        </Modal>
    );
};

export default CardDetailsModal;
